import React,{Component} from 'react'

import { AreaChart, Area, XAxis, YAxis, Tooltip } from 'recharts';
// import {Radar, RadarChart, PolarGrid, Legend, PolarAngleAxis, PolarRadiusAxis,Tooltip,} from 'recharts';

import {
  Primary,
  Accent,
} from '../helper/consts'

export default class CompanyStatsChart extends Component{
  render () {
    const {data} = this.props;
    return (
      <AreaChart  width={460} height={200} data={data} margin={{top: 20, right: 10, left: 0, bottom: 20}}>
        <XAxis dataKey="name" hide/>
        <YAxis type='number' domain={[0, 100]}  scale={'auto'} allowDecimals={false} tickLine={false} interval={'preserveStartEnd'} stroke={Primary}/>
        <Tooltip/>
        <Area type='monotone' dataKey='score' stroke={Accent} fill={Primary} />
      </AreaChart>
    );
  }
}
// <RadarChart width={460} height={330} outerRadius={150} data={data}>
//   <PolarGrid />
//   <PolarAngleAxis dataKey="score" />
//   <PolarRadiusAxis domain={[0, 100]} axisLine={false} />
//   <Tooltip />
//   <Radar dataKey="score" stroke={Accent} fill={Primary} fillOpacity={0.7}/>
// </RadarChart>



// WEBPACK FOOTER //
// ./src/components/CompanyStatsChart.js